export class SectionAsync extends window.BAO.CustomElement() {
  isBusy = false

  static get styles () {
    return `:host { display: contents }`
  }

  static get requiredAttributes () {
    return ['data-section-id']
  }

  connectedCallback () {
    super.connectedCallback()

    // TODO: Implement lazy
    this.render()
  }

  checkValidity () {
    super.checkValidity()
  }

  async render () {
    if (this.isBusy) return

    this.isBusy = true

    const section = await window.BAO.sectionRenderer.fetchSingle(
      this.sectionId,
      this.sectionUrl,
    )
    const html = window.BAO.sectionRenderer.getOuterHtml(section, {
      id: this.sectionId,
    })

    if (!html) {
      this.onEmptySection()

      this.isBusy = false

      return
    }

    this.innerHTML = html

    this.isBusy = false
  }

  onEmptySection () {
    const parent = this.dependantParent

    if (parent) {
      parent.remove()

      console.info(
        `There was no content for dependant section ${parent}.`,
        `Dependant section ${parent} removed.`,
        { sectionId: this.sectionId, url: this.url },
        `The section returned by "${this.identifier}" was empty`,
      )
    }
  }

  get dependantParent () {
    return this.closest('[data-section-async-dependant]')
  }

  /**
   * @returns {boolean} Whether or not this section should load when it's needed instead of at pageload
   */
  get isLazy () {
    return this.getAttribute('loading') === 'lazy'
  }

  /**
   * @returns {string} The ID of the section to be rendered
   */
  get sectionId () {
    return this.getAttribute('data-section-id')
  }

  /**
   * @returns {string} The url, pathname and query parameters
   */
  get sectionUrl () {
    return this.url || window.location.toString()
  }

  /**
   * @returns {string} The URL from which to request the section
   */
  get url () {
    return this.dataset.sectionUrl
  }
}

if (!customElements.get('section-async')) {
  customElements.define('section-async', SectionAsync)
}
